// extracted by mini-css-extract-plugin
export default {"list":"GroupsMenuList_list__zspmU","subheader":"GroupsMenuList_subheader__mnHHT"};